(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6890],{

/***/ 94899:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms",
      function () {
        return __webpack_require__(87625);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 23915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ MarkdownRender; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32583);
/* harmony import */ var _MarkdownRender_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85142);
/* harmony import */ var _MarkdownRender_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_MarkdownRender_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const MarkdownRender = (param)=>{
    let { content  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            style: {
                display: "flex",
                flexDirection: "column",
                maxWidth: 840
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_markdown__WEBPACK_IMPORTED_MODULE_2__/* .ReactMarkdown */ .D, {
                components: {
                    p: (param)=>/*#__PURE__*/ {
                        let { node , ...props } = param;
                        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: (_MarkdownRender_module_scss__WEBPACK_IMPORTED_MODULE_3___default().paragraph),
                            ...props
                        });
                    },
                    h1: (param)=>{
                        let { node , ...props } = param;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_MarkdownRender_module_scss__WEBPACK_IMPORTED_MODULE_3___default().heading), (_MarkdownRender_module_scss__WEBPACK_IMPORTED_MODULE_3___default().h1)),
                            ...props
                        });
                    },
                    h2: (param)=>{
                        let { node , ...props } = param;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: (_MarkdownRender_module_scss__WEBPACK_IMPORTED_MODULE_3___default().heading),
                            ...props
                        });
                    },
                    h3: (param)=>{
                        let { node , ...props } = param;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: (_MarkdownRender_module_scss__WEBPACK_IMPORTED_MODULE_3___default().heading),
                            ...props
                        });
                    },
                    h4: (param)=>{
                        let { node , ...props } = param;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                            className: (_MarkdownRender_module_scss__WEBPACK_IMPORTED_MODULE_3___default().heading),
                            ...props
                        });
                    },
                    h5: (param)=>{
                        let { node , ...props } = param;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                            className: (_MarkdownRender_module_scss__WEBPACK_IMPORTED_MODULE_3___default().heading),
                            ...props
                        });
                    },
                    h6: (param)=>{
                        let { node , ...props } = param;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                            className: (_MarkdownRender_module_scss__WEBPACK_IMPORTED_MODULE_3___default().heading),
                            ...props
                        });
                    }
                },
                children: content
            })
        })
    });
};


/***/ }),

/***/ 62223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Section; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Section_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50246);
/* harmony import */ var _Section_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Section_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const Section = (param)=>{
    let { reverseMobile , className , children , noYBottomPadding , noYTopPadding , grid , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ...props,
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, (_Section_module_scss__WEBPACK_IMPORTED_MODULE_3___default().section), {
            [(_Section_module_scss__WEBPACK_IMPORTED_MODULE_3___default().sectionReverseMobile)]: reverseMobile,
            [(_Section_module_scss__WEBPACK_IMPORTED_MODULE_3___default().noYTopPadding)]: noYTopPadding,
            [(_Section_module_scss__WEBPACK_IMPORTED_MODULE_3___default().noYBottomPadding)]: noYBottomPadding,
            [(_Section_module_scss__WEBPACK_IMPORTED_MODULE_3___default().gridSection)]: grid
        }),
        children: children
    });
};


/***/ }),

/***/ 87625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_common_Navbar_Navbar__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77911);
/* harmony import */ var _components_common_Section_Section__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62223);
/* harmony import */ var _components_common_Footer_Footer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5945);
/* harmony import */ var _components_common_CallToAction_FooterCallToAction__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16314);
/* harmony import */ var _components_common_Head_Meta__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50745);
/* harmony import */ var _components_MarkdownRender_MarkdownRender__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23915);







const Terms = (param)=>{
    let { content  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_Head_Meta__WEBPACK_IMPORTED_MODULE_5__/* .Meta */ .h, {
                title: "Highlight: Terms of Service",
                description: "Highlight Terms of Service"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_Navbar_Navbar__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_Section_Section__WEBPACK_IMPORTED_MODULE_2__/* .Section */ .$, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MarkdownRender_MarkdownRender__WEBPACK_IMPORTED_MODULE_6__/* .MarkdownRender */ .J, {
                            content: content
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_CallToAction_FooterCallToAction__WEBPACK_IMPORTED_MODULE_4__/* .FooterCallToAction */ .Z, {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_Footer_Footer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Terms);


/***/ }),

/***/ 85142:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"MarkdownRender_paragraph__0QV3s","heading":"MarkdownRender_heading__py9Nq","h1":"MarkdownRender_h1__iBIjh"};

/***/ }),

/***/ 50246:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__2Pzmc","gridSection":"Section_gridSection__vgdkS","noYTopPadding":"Section_noYTopPadding__CWdmK","noYBottomPadding":"Section_noYBottomPadding__efv2e","sectionReverseMobile":"Section_sectionReverseMobile__q0tjM"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,4617,6556,3826,1003,2583,2232,8179,3132,9774,2888,179], function() { return __webpack_exec__(94899); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);